import { Component } from '@angular/core';
import {  TiktokAttributeComponent } from './tiktok-attribute.component';



@Component({
    selector: 'tiktok-attribute-var',
    templateUrl: './tiktok-attribute.component.html',
    styleUrl: './tiktok-attribute.component.scss',
    standalone: false
})
export class TiktokAttributeVarComponent extends TiktokAttributeComponent   {

  
  variacao = true;
  table = 'Mktptiktokatributovar';
  

}
